import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import Swal from "sweetalert2";

const ServiceTeam = () => {
  const seller_id = localStorage.getItem("seller_id");
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

    const fetchTeam = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseurl}getServiceMenBySellerId/${seller_id}`);
      setTeam(res.data.data || []);
    } catch (error) {
      console.error("Error fetching service team:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this team member?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.delete(`${baseurl}deleteServiceManById/${id}`);
        await Swal.fire("Deleted!", "Service man has been deleted.", "success");
        fetchTeam(); // Refresh list
      } catch (error) {
        console.error("Error deleting service man:", error);
        Swal.fire("Error", "Failed to delete service man.", "error");
      }
    }
  };

  useEffect(() => {
    if (seller_id) fetchTeam();
  }, [seller_id]);


  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <SellerSidebar />
              </div>
              <div className="col-md-10">
                <div className="reviewcls text-start">
                  <h4 className="selh1 mb-3">Service Team</h4>
                  <Link to="/seller/service-team-create" className="btn btn-primary mb-3">
                    Add Service Team
                  </Link>

                  <Link to="/seller/service-request" className="btn btn-primary mb-3 ms-3">
                    All Service Requests
                  </Link>
 

                  <div className="card p-3">
                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                      <div className="table-responsive">
                        <table className="custom-table">
                          <thead className="">
                            <tr>
                              <th>Name</th>
                              <th>Phone</th>
                              <th>Email</th>
                              <th>Experience</th>
                              <th>PAN</th>
                              <th>Aadhar</th>
                              <th>Resume</th>
                              <th>Profile Image</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {team.length > 0 ? (
                              team.map((member) => (
                                <tr key={member.id}>
                                  <td>{member.name}</td>
                                  <td>{member.phone}</td>
                                  <td>{member.email}</td>
                                  <td>{member.experience}</td>
                                  <td>{member.pan_card}</td>
                                  <td>{member.aadhar_card}</td>
                                  <td>
  {member.resume ? (
    member.resume.split(",").map((file, idx) => (
      <div key={idx}>
        <a
          href={`${imageUrl}servicefile/${file}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          View {idx + 1}
        </a>
      </div>
    ))
  ) : (
    "N/A"
  )}
</td>

<td>
  {member.profile_image ? (
    member.profile_image.split(",").map((file, idx) => (
      <img
        key={idx}
        src={`${imageUrl}servicefile/${file}`}
        alt={`Profile ${idx + 1}`}
        width="50"
        height="50"
        style={{ marginRight: "5px" }}
      />
    ))
  ) : (
    "N/A"
  )}
</td>

                                  <td>
                                    <Link
                                      to={`/seller/service-team-edit/${member.id}`}
                                      className="btn btn-sm btn-info me-2"
                                    >
                                      Edit
                                    </Link>
                                    <button
                                      onClick={() => handleDelete(member.id)}
                                      className="btn btn-sm btn-danger"
                                    >
                                      Delete
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="9" className="text-center">
                                  No service team members found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ServiceTeam;
